import type { ResultOf } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";

// Query performance of current path membership

export const query = graphql(`
  query AppPerformancePathMembershipQuery($id: ID!) {
    pathMembership(id: $id) {
      id
      person { id }
      learningPath {
        id
        fixed
        numMembers
        membersPastCheckpoint
        membersPastGoal
        checkpoint
        goal
        leaderboards {
          id
          name
          mode
          specifiedTasks { id }
          specifiedFeedbackTasks { id }
          rankings {
            pathMembershipId
            firstName
            lastName
            rank
            miles
          }
        }
        scoreboards {
          id
          name
          score
          specifiedTasks { id }
          specifiedFeedbackTasks { id }
        }
      }
      pathGroup { id }
      startDate
      endDate
      taskTime
      mySpeed
      ourSpeed
      miles
      pathGroupMemberMiles
      pathGroupMiles
      pathGroupMilesAvg
      allPathGroupMiles
      pathGroupSpeed
      memberMiles
      rank
      greenGoal
      yellowGoal
    }
  }
`);

export type IData = ResultOf<typeof query>;

// Learning path query for task details
export const learningPathQuery = graphql(`
  query AppPerformanceLearningPathQuery($id: ID!) {
    learningPath(id: $id) {
      id
      learningPathItems {
        id
        type
        tasks { id icon shortTitle }
        feedbackTask { id icon shortTitle }
      }
    }
  }
`);
